<template>
  <div>
    <wx-my-profile :show-start-work="showStartWork"></wx-my-profile>
    <div class="van-hairline--top" style="margin: 0 0 20px 0"></div>
    <div style="display: flex; justify-content: center; padding-top: 20px">
      <div
        style="width: 100px; background-color: lightgrey; border-radius: 5px; padding: 6px 10px; margin-right: 20px; text-align: center">
        <div>上班 {{workPlanConfig.beginTime}}</div>
        <div style="font-size: 14px">
          <div v-if="punchInTime">{{punchInTime}} 已打卡</div>
          <div v-else>未打卡</div>
        </div>
      </div>
      <div style="width: 100px; background-color: lightgrey; border-radius: 5px; padding: 6px; text-align: center">
        <div>下班 {{workPlanConfig.endTime}}</div>
        <div style="font-size: 14px">
          <div v-if="punchOutTime">{{punchOutTime}} 已打卡</div>
          <div v-else>未打卡</div>
        </div>
      </div>
    </div>
    <div style="display: flex; justify-content: center; align-items: center; height: calc(100vh - 340px)">
      <van-button type="info"
                  :disabled="!!punchOutTime"
                  style="width: 160px; height: 160px; border-radius: 80px; font-weight: bold"
                  @click="punch">
        <template v-if="!punchOutTime">
          <div style="font-size: 23px;">{{punchText}}</div>
          <div style="font-size: 17px; margin-top: 6px">{{currentTime}}</div>
        </template>
        <div v-else style="font-size: 23px;">已下班</div>
      </van-button>
    </div>
  </div>
</template>

<script>
  import WxMyProfile from '@/views/wx/WxMyProfile'
  import { Button } from 'vant'

  export default {
    name: 'WxPunch',
    components: {
      WxMyProfile,
      [Button.name]: Button
    },
    props: {
      workPlanConfig: Object
    },
    data () {
      return {
        currentTime: new Date().format('hh:mm:ss')
      }
    },
    created () {
      const timer = setInterval(() => {
        this.currentTime = new Date().format('hh:mm:ss')
      }, 1000)
      this.$once('hook:beforeDestroy', function () {
        clearInterval(timer)
      })
    },
    methods: {
      punch () {
        if (!this.punchInTime) {
          this.$store.dispatch('user/punchIn')
        } else if (!this.punchOutTime) {
          this.$store.dispatch('user/punchOut')
        }
      },
      xxx () {
      }
    },
    computed: {
      punchInTime () {
        const time = this.$store.state.user.punchInTime
        if (!time) return null
        return time.split(' ')[1].substring(0, 5)
      },
      punchOutTime () {
        const time = this.$store.state.user.punchOutTime
        if (!time) return null
        return time.split(' ')[1].substring(0, 5)
      },
      punchText () {
        if (!this.punchInTime) {
          return '上班打卡'
        } else if (!this.punchOutTime) {
          return '下班打卡'
        }
        return ''
      },
      showStartWork () {
        return this.$isTechnician() && !!this.punchInTime && !this.punchOutTime
      }
    }
  }
</script>

<style scoped>

</style>
